import { StepProps } from "../../../../components/Stepper"
import { BuyData } from "../../../../types/steps/buy"
import { useNavigate } from "react-router-dom"
import { useRequest } from "../../../../hooks/useRequest"
import SbpOrderPayment from "../../../../features/buy/SbpOrderPayment"

export default function Sbp({ params }: StepProps<BuyData>) {
    const { orderNumber, orderId, qrImage, sbpBanks, orderCreatedAt, orderExpiredAt } = params
    const route = useNavigate()

    return (
        <SbpOrderPayment
            orderId={orderId}
            orderNumber={orderNumber!}
            qrImage={qrImage}
            initialSbpBanks={sbpBanks}
            orderCreatedAt={orderCreatedAt}
            orderExpiredAt={orderExpiredAt}
            onPaid={() => route("/tickets")}
            onExpired={() => route(-1)}
            onCancelOrder={() => route(-1)}
        />
    )
}
